// ═══════════════════════════════════════
// ABC-DIRECTIVES — Règles de directives contextuelles
//
// Structure d'une règle :
// {
//   instruments: string[]   — slugs qui doivent TOUS être présents
//   key:         RegExp     — regex testée sur la valeur K: (optionnel)
//   voiceAttrs:  string     — attributs à fusionner sur la ligne V:N existante
//                             (ex: 'stem=up'). {v} est résolu mais inutile ici.
//   preK:        string[]   — lignes à insérer AVANT K:
//   postK:       string[]   — lignes à insérer APRÈS K:
//                             Utiliser {v} comme placeholder pour le numéro de voix
//                             ex: 'V:{v} stem=down' → 'V:2 stem=down' pour la voix 2
// }
//
// Les directives preK listées dans MANAGED_PRE_PREFIXES sont retirées
// et recalculées à chaque appel de updateVoiceFromForm().
// ═══════════════════════════════════════

export const ABC_DIRECTIVE_RULES = [

    // ── Cornemuse — toujours ─────────────────────────────────────────────────
    /*{
        instruments: ['bagpipe'],
        preK: ['%%graceslurs 0'],
    },*/

    // ── Cornemuse bretonne (K:Cmin) ──────────────────────────────────────────
    {
        instruments: ['bagpipe'],
        key:  /^Cm(in(or)?)?$/i,
        voiceAttrs: 'stem=up',
        postK: ['%%bagpipes'],
    },

    // ── Caisse claire (percussion) ────────────────────────────────────────────
    /*{
        instruments: ['snare_drum'],
        preK: [
            '%%MIDI channel 10',
            '%%MIDI drummap A 40',
            '%%MIDI drummap c 40',
            '%%graceslurs 0',
        ],
        postK: ['V:{v} stem=down'],
    },*/

];

export const MANAGED_PRE_PREFIXES = [
    '%%graceslurs',
    '%%bagpipes',
    '%%MIDI channel',
    '%%MIDI drummap',
];